import { Body } from 'components/text';

import Link from 'next/link';

const TermsAndConditions = () => {
  return (
    <section>
      <Body>
        By completing this e-gift card purchase I understand and agree to the{' '}
        <Link href="/terms-and-conditions">
          <a target="_blank">terms and conditions.</a>
        </Link>
      </Body>
    </section>
  );
};

export default TermsAndConditions;
